/**
 * Gets the status tiers configuration for points and diamonds dialog
 * @param {Function} t - Translation function from react-i18next
 * @param {Object} statusIcons - Object containing status icon components
 * @returns {Array} Array of status tier objects
 */
export function getStatusTiers(t, statusIcons) {
    return [
        {
            icon: statusIcons.StatusTraveller,
            label: t('Diamonds.StatusTraveller'),
            points: '2',
            diamonds: '1',
            colorClass: 'traveller',
        },
        {
            icon: statusIcons.StatusSilver,
            label: t('Diamonds.StatusSilver'),
            points: '2',
            diamonds: '1',
            colorClass: 'silver',
        },
        {
            icon: statusIcons.StatusGold,
            label: t('Diamonds.StatusGold'),
            points: '3',
            diamonds: '1',
            colorClass: 'gold',
        },
        {
            icon: statusIcons.StatusPlatinum,
            label: t('Diamonds.StatusPlatinum'),
            points: '4',
            diamonds: '1',
            colorClass: 'platinum',
        },
        {
            icon: statusIcons.StatusTopPlatinum,
            label: t('Diamonds.StatusTopPlatinum'),
            points: '5',
            diamonds: '1',
            colorClass: 'top-platinum',
        },
    ];
}

